import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpConfigService } from '../../core/httpConfig/httpConfigService';
import { IBasicInfo } from '../../appInterfaces/IBasicInfo';
import { LocalStorageService } from '../localstorage/localstorage.service';
import { environment } from '../../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class BasicInfoService {
  api: string;
  basicInfo = new BehaviorSubject<IBasicInfo | null>(null);
  S3_URL = environment.S3_URL;
  constructor(
    private apiConfig: HttpConfigService,
    private localStorageService: LocalStorageService,
    private titleService: Title,
    private metaService: Meta
  ) {
    this.api = this.apiConfig.getBaseUrl + "account-settings";
  }

  getBasicInfoFromAPI(): Observable<IBasicInfo> {
    return this.apiConfig.get(this.api);
  }


  /*------------------------------------------------------------------
    Basic Info (Resolver code)
  -------------------------------------------------------------------*/

  /**
     * get basic info
     */
  public getBasicInfo(forecGet?: boolean) {
    const tenantName = this.localStorageService.getItem('tenant') ?? '';
    if (!tenantName) {
      return;
    }

    const basicInfo = this.localStorageService.getItem("basic-info");

    if (basicInfo) {
      const parsedInfo = JSON.parse(basicInfo);
      if (forecGet) {
        this.getBasicInfoFromAPI().subscribe(res => {
          this.setBasicInfo(res);
        });
      }else{
        this.basicInfo.next(parsedInfo);
      }
    }else{
      this.getBasicInfoFromAPI().subscribe(res => {
        this.setBasicInfo(res);
      });
    }
  }

  

  public setBasicInfo(basicInfo: IBasicInfo) {
    this.localStorageService.setItem("basic-info", JSON.stringify(basicInfo));
    this.basicInfo.next(basicInfo);
    this.updateMetaTags(basicInfo);
  }

  /**
   * clear basic info
   */
  public clearBasicInfo() {
    this.basicInfo.next(null);
    this.localStorageService.removeItem('basic-info');
  }


  private updateMetaTags(info: IBasicInfo) {
    debugger
    const title = info.restaurantName || 'Restaurant';
    const description = info.description || '';
    const imageUrl = info.imageLink
      ? `${this.S3_URL}${info.bucketName}/${info.imageLink}`
      : null;

    // Page title
    this.titleService.setTitle(title);

    // Standard meta
    this.metaService.updateTag({ name: 'description', content: description });

    // Open Graph
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    if (imageUrl) {
      this.metaService.updateTag({ property: 'og:image', content: imageUrl });
    }

    // Twitter
    this.metaService.updateTag({ name: 'twitter:title', content: title });
    this.metaService.updateTag({ name: 'twitter:description', content: description });
    if (imageUrl) {
      this.metaService.updateTag({ name: 'twitter:image', content: imageUrl });
      this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    }
  }


}
